
import { NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { ColorOptions } from '@df/ui/atomic/atomic-options';


export const OFF_CANVAS_MENU_FIELD = <NICmsContentField.IRepeaterField>{
    type: NICmsContentField.EFieldType.repeater,
    key: 'menu',
    title: 'Menu Items',
    itemName: 'Item',
    itemNameField: 'text',
    defaultSize: 3,
    fields: [
        {
            key: 'text',
            type: NICmsContentField.EFieldType.text,
            title: 'Item text',
            default: 'Some link',
            required: true
        },
        {
            key: 'link',
            type: NICmsContentField.EFieldType.text,
            title: 'Link'
        },
        <NICmsContentField.IChoiceField>{
            key: 'color',
            title: 'Color',
            type: NICmsContentField.EFieldType.choice,
            colorPreview: true,
            options: ColorOptions,
            description: 'Text color'
        },
        <NICmsContentField.IField>{
            key: 'secondLevelTurnOn',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Level 2 turn on',
            default: false
        },
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'secondLevelItems',
            title: 'Level 2 Items',
            itemName: 'Item',
            itemNameField: 'title',
            fields: [
                {
                    key: 'text',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Item text',
                    default: 'Some link',
                    required: true
                },
                {
                    key: 'link',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Link'
                },
                <NICmsContentField.IChoiceField>{
                    key: 'color',
                    title: 'Color',
                    type: NICmsContentField.EFieldType.choice,
                    colorPreview: true,
                    options: ColorOptions,
                    description: 'Text color'
                },
                <NICmsContentField.IField>{
                    key: 'thirdLevelTurnOn',
                    type: NICmsContentField.EFieldType.toggle,
                    title: 'Level 3 turn on',
                    default: false
                },
                <NICmsContentField.IField>{
                    key: 'featuredCarouseTurnOn',
                    type: NICmsContentField.EFieldType.toggle,
                    title: 'Featured carousel turn on',
                    default: false
                },
                <NICmsContentField.IRepeaterField>{
                    type: NICmsContentField.EFieldType.repeater,
                    key: 'thirdLevelItems',
                    title: 'Level 3 Items',
                    itemName: 'Item',
                    itemNameField: 'title',
                    fields: [
                        {
                            key: 'text',
                            type: NICmsContentField.EFieldType.text,
                            title: 'Item text',
                            default: 'Some link',
                            required: true
                        },
                        {
                            key: 'link',
                            type: NICmsContentField.EFieldType.text,
                            title: 'Link'
                        },
                        <NICmsContentField.IChoiceField>{
                            key: 'color',
                            title: 'Color',
                            type: NICmsContentField.EFieldType.choice,
                            colorPreview: true,
                            options: ColorOptions,
                            description: 'Text color'
                        }
                    ],
                    canShow: data => data.thirdLevelTurnOn
                },
                <NICmsContentField.IField>{
                    key: 'featuredHeader',
                    type: NICmsContentField.EFieldType.text,
                    itemName: 'Featured header',
                    title: 'Featured header',
                    canShow: data => data.featuredCarouseTurnOn
                },
                {
                    type: NICmsContentField.EFieldType.repeater,
                    key: 'featuredCarousel',
                    title: 'Featured carousel',
                    itemName: 'Featured carousel',
                    itemNameField: 'text',
                    fields: [
                        <NICmsContentField.IField>{
                            key: 'image',
                            type: NICmsContentField.EFieldType.image,
                            title: 'Image'
                        },
                        <NICmsContentField.IField>{
                            key: 'text',
                            type: NICmsContentField.EFieldType.text,
                            title: 'Item text',
                            default: 'Some title'
                        },
                        <NICmsContentField.IField>{
                            key: 'link',
                            type: NICmsContentField.EFieldType.text,
                            title: 'Link'
                        }
                    ],
                    canShow: data => data.featuredCarouseTurnOn
                }
            ],
            canShow: data => data.secondLevelTurnOn
        }
    ]
}

export const OFF_CANVAS_BLOCK_ID = 'off-canvas-menu'; // back forward compatibility for already saved data

export const OFF_CANVAS_BLOCK_CONFIG: Omit<NICmsContentComponent.IMeta<NICmsContentComponent.IComponent>, 'type'> = {
    id: OFF_CANVAS_BLOCK_ID,
    onDemandOnly: true,
    block: {
        url: OFF_CANVAS_BLOCK_ID,
        scope: 'website',
        autoload: 'prerender'
    },
    name: 'Off Canvas Menu',
    description: 'Off canvas menu component',
    fields: [
        OFF_CANVAS_MENU_FIELD,
        {
            type: NICmsContentField.EFieldType.repeater,
            key: 'footerLinks',
            title: 'Footer Links',
            itemName: 'Item',
            itemNameField: 'text',
            fields: [
                <NICmsContentField.IChoiceField>{
                    key: 'icons',
                    type: NICmsContentField.EFieldType.choice,
                    title: 'Icons',
                    options: [
                        { key: 'icon-account', title: 'Account' },
                        { key: 'icon-phone', title: 'Phone' },
                        { key: 'icon-help', title: 'Help' },
                        { key: 'icon-information', title: 'Information' },
                        { key: 'icon-location', title: 'Location' }
                    ]
                },
                <NICmsContentField.IField>{
                    key: 'text',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Item text',
                    default: 'Some link',
                    required: true
                },
                <NICmsContentField.IField>{
                    key: 'link',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Link'
                }
            ]
        },
        {
            type: NICmsContentField.EFieldType.label,
            key: 'featuredHeader',
            title: 'Featured header'
        }
    ]
}